/* eslint-disable react/no-array-index-key */
import React, { useEffect, useRef, useState } from 'react';
import usePagination from '../../hooks/usePagination';
export default function Pagination(props) {
    const { totalNumResults, resultsPerPage, windowSize = 5, children } = props;
    const [pageWindowSize, setPageWindowSize] = useState(windowSize);
    const pagesRef = useRef(null);
    const { currentPage, goToPage, nextPage, prevPage, pages, totalPages } = usePagination({
        totalNumResults,
        resultsPerPage,
        windowSize: pageWindowSize,
    });
    useEffect(() => {
        setPageWindowSize(windowSize);
    }, [windowSize]);
    // Calculate windowSize on resize event
    useEffect(() => {
        const resize = () => {
            const parentSize = Number(pagesRef.current?.parentElement?.clientWidth) || window.innerWidth;
            setPageWindowSize(Math.max(1, Math.min(Math.floor(parentSize / 60) - 4, windowSize)));
        };
        resize();
        window.addEventListener('resize', resize);
        return () => {
            window.removeEventListener('resize', resize);
        };
    }, [windowSize]);
    return (React.createElement(React.Fragment, null, typeof children === 'function' ? (children({
        currentPage,
        goToPage,
        nextPage,
        pages,
        prevPage,
        totalPages,
    })) : (React.createElement("div", { ref: pagesRef, className: 'cio-pagination' },
        React.createElement("button", { onClick: () => prevPage(), type: 'button', "data-testid": 'cio-pagination-prev-button' }, "<"),
        pages.map((page, i) => (React.createElement("button", { onClick: () => goToPage(page), type: 'button', key: `${page},${i}`, className: currentPage === page ? 'selected' : '' }, page === -1 ? React.createElement("span", null, "...") : page))),
        React.createElement("button", { onClick: () => nextPage(), type: 'button', "data-testid": 'cio-pagination-next-button' }, ">")))));
}
Pagination.defaultProps = {
    resultsPerPage: 20,
    windowSize: 5,
};
